<script setup lang="ts">
type Props = {
  label: string;
  active?: boolean;
  size?: 'default' | 'small';
};

defineProps<Props>();

const emit = defineEmits<{ click: [] }>();
</script>

<template>
  <button
    :class="[
      'filter-tab-button',
      { 'filter-tab-button--active tab-glow-active': active },
      { 'filter-tab-button--small': size === 'small' },
    ]"
    @click="emit('click')"
  >
    {{ label }}
  </button>
</template>

<style scoped>
.filter-tab-button {
  padding: 8px 12px;
  font-weight: 700;
  height: 32px;
  border-radius: 12px;
  background: var(--colors-flat-default-flat, rgba(63, 63, 70, 0.4));
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border: none;
  outline: none;
  transition: filter 0.2s;
  flex-shrink: 0;
}

.filter-tab-button--small {
  height: 34px;
  padding: 7px 15px;
  font-size: 11px;
}

.filter-tab-button--active {
  font-weight: 700;
  opacity: 1;
}

@media (min-width: 768px) {
  .filter-tab-button:not(.filter-tab-button--small) {
    height: 44px;
    padding: 12px 24px;
  }
}
</style>
